import { expandBySlide } from '../util/utils';
export default {

  init() {
    const forms = document.querySelectorAll('.sign-up-form');

    forms.forEach(form => {
      const extraFields = form.querySelector('.js-extra-fields');
      const emailField = form.elements["newsletter-mail"];
      const messageBox = form.querySelector('.message-box');
      const button = form.querySelector('button');


      if (emailField && extraFields) {
        emailField.addEventListener('focus', () => {
          form.classList.add('is-expanded')
          expandBySlide(extraFields)
        }, {
          once: true,
        });
      }

      form.addEventListener('submit', event => {
        if (button.classList.contains('is-loading')) return;
        this.sendForm(event, form, button, messageBox)
      });

      if (form.parentNode.classList.contains('mail-sign-up--slide-in') && !this.getHideCookie()) {
        this.handleSlideInScroll(form);
      }
    });

    // Expand the slide in sign up form
    const expandSlide = document.querySelector('.js-expand-slide-in');
    if(expandSlide) {
      expandSlide.addEventListener('click', event => {
        const component = event.target.parentNode;
        component.classList.add('is-grown');
      });
    }

    // Hide the slide in sign up form
    const hideSlide = document.querySelector('.js-hide-slide-in');
    if(hideSlide) {
      hideSlide.addEventListener('click', event => {
        event.target.parentNode.style.display = 'none';
        event.preventDefault();
        this.setHideCookie();
      });
    }
  },

  /**
   * Hide the form on click
   * and set a cookie to hide it for an x time
   * @param {Node} form
   */
  handleSlideInScroll(form) {
    const pageHeight = document.body.scrollHeight;
    const windowHeight = window.innerHeight;
    let isScrolling = null

    // Define this function so we can remove it
    const scrollEvent = function(){
      window.clearTimeout(isScrolling);
      // Only exec every 200ms
      isScrolling = setTimeout(() => {
        // Get the current position
        const scrolPosition = window.pageYOffset;

        // Check if we're over 60 percent
        if ( 100 / pageHeight * (scrolPosition + windowHeight) > 40) {
          // Update the styles
          form.parentNode.style.display = 'block';
          setTimeout(() => {
            requestAnimationFrame(() => form.parentNode.classList.add('is-slided'));
          }, 50);

          // And remove this event
          window.removeEventListener('scroll', scrollEvent);
        }
      }, 30);
    }

    window.addEventListener('scroll', scrollEvent);
  },

  /**
   * Check if the hide cookie is  set
   */
  getHideCookie() {
    return document.cookie.indexOf('hideSlideInNewsletter=') !== -1;
  },

  /**
   * Set the slide hide cookie for three days
   */
  setHideCookie(duration = 259200000) { // 3 days
    const date = new Date();
    date.setTime(date.getTime() + duration);
    document.cookie = 'hideSlideInNewsletter=true; path=/; samesite=lax; secure; expires=' + date.toUTCString() + ';';
  },


  /**
   * Submit the form via AJax
   * @param {object} event
   * @param {Node} form
   * @param {Node} button
   * @param {Node} messageBox
   */
  sendForm(event, form, button, messageBox) {
    // Hide the previous message
    messageBox.classList.add('u-hidden-visually');

    // Bind the FormData object and the form element
    const formData = new FormData( form );
    formData.append('action', 'schouten_subscribe_user');

    if (window.schoutenTheme && window.schoutenTheme.ajaxurl)

    this.setLoadState(button, messageBox);
    fetch(window.schoutenTheme.ajaxurl, {
        body: formData,
        method: "post",
      })
      .then(resp => resp.json())
      .then(data =>  {
        if (data.success) {
          this.setSuccessMessage(messageBox);
          form.reset();
          this.setHideCookie(92275200000) // 3 years
        } else {
          if(data.data === 'spammer') return window.location.href = "/k4h8gn57sh";
          this.setErrorMessage(messageBox, data.data);
        }
      })
      .catch(err => {
        this.setErrorMessage(messageBox);
        // eslint-disable-next-line
        console.error(err)
      })
      .finally(() => this.removeLoadState(button));

    // Define what happens on successful data submission
    event.preventDefault();
  },

  setLoadState(formButton, messageBox) {
    if (formButton) {
      formButton.classList.add('is-loading');
    }
    if (messageBox) {
      messageBox.classList.add('u-hidden-visually');
      messageBox.textContent = 'Submitting...';
    }
  },

  removeLoadState(formButton) {
    if (formButton) {
      formButton.classList.remove('is-loading');
    }
  },

  setErrorMessage(messageBox, message = false) {
    const defaultMessage = window.schoutenTheme.formError || 'Something went wrong, please try again later.'
    messageBox.classList.remove('is-success');
    messageBox.classList.remove('u-hidden-visually');
    messageBox.classList.add('is-error');
    messageBox.innerText = message ? message : defaultMessage;
  },

  setSuccessMessage(messageBox) {
    messageBox.classList.remove('is-error');
    messageBox.classList.remove('u-hidden-visually');
    messageBox.classList.add('is-success');
    messageBox.innerText = window.schoutenTheme.newsletterSuccess || 'Submission successfull! Please check your mail for the confirmation message to complete your subscription.';
  },
}
